import styled from 'styled-components'

import { Grid } from '@components/ui/Grid'

export const ContentWrapperDiv = styled.div`
  max-width: 530px;
`

export const GridWithDivider = styled(Grid)`
  position: relative;
  padding-top: 20px;

  * + & {
    margin-top: 20px;
  }

  &::before {
    content: '';
    width: calc(100% + 60px);
    position: absolute;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.gray[105]};
    left: -30px;
    top: 0;
  }
`
